/**
 * ヘッダーのドロワーメニューを実行するクラス
 */

export default class DrawerMenu {
  constructor() {
    this.drawerMenu = document.querySelector('#js-drawer-menu');
    this.drawerMenuButton = document.querySelector('#js-menu-button');
    this.drawerOpenClass = 'is-drawer-menu-open';
    this.isOpen = false;
    this.scrollPosition = 0;
    this.handleTouchMove = this.handleTouchMove.bind(this);
  }

  handleTouchMove(ev) {
    // ドロワーメニュー内でのスクロールは許可
    if (this.drawerMenu && this.drawerMenu.contains(ev.target)) {
      return;
    }
    // それ以外のスクロールは防止
    ev.preventDefault();
  }

  open() {
    if (this.isOpen) return;
    // 現在のスクロール位置を保存
    this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    // bodyを固定
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this.scrollPosition}px`;
    document.body.style.width = '100%';
    // タッチイベントでスクロールを防止
    document.addEventListener('touchmove', this.handleTouchMove, { passive: false });
    document.body.classList.add(this.drawerOpenClass);
    this.isOpen = true;
  }

  close() {
    if (!this.isOpen) return;
    // bodyの固定を解除
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    // スクロール位置を復元
    window.scrollTo(0, this.scrollPosition);
    // タッチイベントリスナーを削除
    document.removeEventListener('touchmove', this.handleTouchMove);
    document.body.classList.remove(this.drawerOpenClass);
    this.isOpen = false;
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  init() {
    if (!this.drawerMenuButton || !this.drawerMenu) return;

    // メニューボタンのクリックイベント
    this.drawerMenuButton.addEventListener('click', (ev) => {
      ev.preventDefault();
      this.toggle();
    });

    // メニュー内のリンクをクリックしたら閉じる
    const menuLinks = this.drawerMenu.querySelectorAll('a');
    menuLinks.forEach((link) => {
      link.addEventListener('click', () => {
        this.close();
      });
    });
  }
}
